// hooks/useLoadContentfulTranslations.ts
import { useContentfulLocaleStrings } from 'api/hooks/useContentfulLocaleStrings';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useLoadContentfulTranslations = (locale: string) => {
    const { i18n } = useTranslation();
    const { data, isLoading, error } = useContentfulLocaleStrings(locale);

    useEffect(() => {
        if (data) {
            // Add or update the resource bundle for the given locale
            if (!i18n.hasResourceBundle(locale, 'translation')) {
                i18n.addResourceBundle(locale, 'translation', data, true, true);
            } else {
                // Update existing resource bundle (overwrite: true)
                i18n.addResourceBundle(locale, 'translation', data, true, true);
            }
        }
    }, [data, locale, i18n]);

    return { isLoading, error };
};
